import { useMemo } from 'react';
import NavItem from './NavItem';
import SocialLinks from './SocialLinks';
import avatarImage from '../img/dave-web.jpg';
import { navItems } from '../lib/constants';
import { NavLink, useLocation } from 'react-router-dom';

const Nav = () => {
  const { pathname } = useLocation();
  const HeadingEl = useMemo(() => {
    return pathname === '/' ? 'h1' : 'p';
  }, [pathname]);

  return (
    <header
      role="banner"
      className="py-4 border-b border-amber-500 border-dashed"
    >
      <div className="container max-w-screen-md mx-auto px-4">
        <div className="flex items-center gap-4">
          <NavLink
            to="/"
            className="block no-underline"
            aria-label="Navigate to homepage"
          >
            <div className="max-w-[4.5rem]">
              <img
                className="block max-w-full rounded-full overflow-hidden"
                src={avatarImage}
                alt="Me"
                width="190"
                height="190"
                loading="lazy"
              />
            </div>
          </NavLink>

          <div className="">
            <HeadingEl className="h1">Dave Wheeldon</HeadingEl>
            <p className="text-lg leading-none">Senior Frontend Engineer</p>
          </div>
        </div>

        <nav role="navigation" className="mt-4">
          <div className="flex items-center gap-4">
            {navItems.map((item) => {
              return (
                <NavItem key={item.label} to={item.path} name={item.label} />
              );
            })}
            <SocialLinks />
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Nav;
